import React from "react";
import { Link } from "react-router-dom";
import './Navbar.css';
const Footer = () => {
  return (
    <footer className="footer">
      <span className="footer-text">© Copyright 2021 All Rights Reserved. Reena Industries |</span>
      <Link to='/contact' className="contact-link">Contact Us</Link> 
    </footer>
  );
};

export default Footer;